import { ApplicationInsights } from '@microsoft/applicationinsights-web'

import { createLogger } from './logger'
import { AppInsightsTransport } from './transports/appInsights'
import { ConsoleTransport } from './transports/console'
import { LogLevel } from './types'

// Get environment configuration
const environment = import.meta.env.VITE_APP_ENV as string
const logLevel = (import.meta.env.VITE_LOG_LEVEL as string) || 'INFO'
const logTransports = (import.meta.env.VITE_LOG_TRANSPORTS as string) || 'console'

// Map string log level to enum
const logLevelMap: Record<string, LogLevel> = {
  DEBUG: LogLevel.DEBUG,
  INFO: LogLevel.INFO,
  WARN: LogLevel.WARN,
  ERROR: LogLevel.ERROR,
  CRITICAL: LogLevel.CRITICAL,
}

const minLevel = logLevelMap[logLevel.toUpperCase()] || LogLevel.INFO

// Initialize transports based on configuration
const transports = []

// Parse transport configuration (comma-separated list)
const transportList = logTransports.split(',').map((t) => t.trim())

// Console transport (local/dev)
if (transportList.includes('console')) {
  transports.push(new ConsoleTransport(minLevel))
}

// Application Insights transport (qal/ppd/prd)
let appInsightsTransport: AppInsightsTransport | null = null
if (transportList.includes('appInsights')) {
  appInsightsTransport = new AppInsightsTransport(
    environment === 'local' || environment === 'dev' ? LogLevel.WARN : LogLevel.ERROR
  )
  transports.push(appInsightsTransport)
}

// Create logger instance
const logger = createLogger({
  minLevel,
  transports,
  environment,
})

/**
 * Initialize Application Insights for the logger
 * Must be called after AppInsights is loaded
 */
export const initAppInsightsLogger = (appInsights: ApplicationInsights) => {
  if (appInsightsTransport) {
    appInsightsTransport.setAppInsights(appInsights)
  }
}

// Export logger instance and types
export { LogLevel } from './types'
export type { LogContext, Logger } from './types'
export { logger }
